import SyncIcon from '@mui/icons-material/Sync';
import { Box, Button } from '@mui/material';
import React from 'react';
import { Loading } from '../../uikit';
import { connectButton, integrationItem, organizationCalendarStatus } from './integrationsStyles';

interface CalendarIntegrationCardProps {
  label: string;
  logoSrc: string;
  isSynced: boolean;
  onConnect: () => void;
  isLoading: boolean;
}

export default function CalendarIntegrationCard({ label, logoSrc, isSynced, onConnect, isLoading }: CalendarIntegrationCardProps) {
  if (isLoading) return <Loading />;

  return (
    <Box sx={integrationItem}>
      <img src={logoSrc} alt={label} height={100} />
      {isSynced ? (
        <Box sx={{ ...organizationCalendarStatus, backgroundColor: 'var(--status-success)', display: 'flex', alignItems: 'center', gap: 0.5 }}>
          Synced <SyncIcon />
        </Box>
      ) : (
        <Button variant="contained" sx={connectButton} onClick={onConnect}>
          Connect
        </Button>
      )}
    </Box>
  );
}
